import { ICertificate } from 'Services/account';
import sessionService from 'Store/module/sessionService';
import moment from "moment";

export enum CertificateState {
    NoAuthorized = 0,
    Authorized = 1,
    Expired = 2
}

class CertificateContext {
    private _state: ICertificateState;
    constructor() {
        this._state = new NoAuthorizedState();
    }

    getState(): ICertificateState {
        this.checkState();
        return this._state;
    }

    changeState(certificateState: ICertificateState) {
        this._state = certificateState;
    }

    private checkState() {
        this._state.checkState(this);
    }
}

interface ICertificateState {
    getState(): CertificateState;
    checkState(context: CertificateContext): void;
}

class NoAuthorizedState implements ICertificateState {
    getState(): CertificateState {
        return CertificateState.NoAuthorized;
    }

    checkState(context: CertificateContext): void {
        const certificate = sessionService.get() as ICertificate;
        if (!certificate) {
            return;
        }
        const expired = moment.utc().toDate();
        if (certificate.expired && new Date(certificate.expired) < expired) {
            context.changeState(new ExpiredState());
            return;
        }

        context.changeState(new AuthorizeddState());
    }
}


class AuthorizeddState implements ICertificateState {
    getState(): CertificateState {
        return CertificateState.Authorized;
    }


    checkState(context: CertificateContext): void {
        const certificate = sessionService.get() as ICertificate;
        if (!certificate) {
            context.changeState(new NoAuthorizedState());
            return;
        }
        const expired = moment.utc().toDate();
        if (certificate.expired && certificate.expired < expired) {
            context.changeState(new ExpiredState());
            return;
        }
    }
}

class ExpiredState implements ICertificateState {
    getState(): CertificateState {
        return CertificateState.Expired;
    }

    checkState(context: CertificateContext): void {
        const certificate = sessionService.get() as ICertificate;
        if (!certificate || (certificate && !certificate.expired)) {
            context.changeState(new NoAuthorizedState());
            return;
        }
        const expired = moment.utc().toDate();
        if (certificate.expired && certificate.expired > expired) {
            context.changeState(new AuthorizeddState());
            return;
        }
       
        sessionService.remove();
    }
}

export default new CertificateContext();